export enum KundenTypeEnum {
    PERSON = 'Person',
    BETRIEB = 'Betrieb',
    ZUWANDERUNGSINTERESSIERTER = 'Zuwanderungsinteressierter',
    KINDERGELDFALL = 'Kindergeldfall'
}